import { Injectable } from '@angular/core';
import { AlarmAgentApiClient, GenericClass } from '.';

@Injectable({
	providedIn: 'root',
})
export class PagerCarrierService {
	private API_ROUTE = 'pagercarrier';

    async getPagerCarrier(): Promise<GenericClass[]> {
		return this.http.get(`${this.API_ROUTE}`).toPromise();
	}
	constructor(private http: AlarmAgentApiClient) {}

}
